import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickMetavariables from '@/components/brick_metavariables.vue'

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-square', 'text-purple']
infos.front_classes = ['far', 'fa-code', 'text-white']
infos.name = 'metavariables'
infos.associated_class_name = 'AutomlMetavariables'
infos.editing_component_name = 'BrickMetavariables'
infos.editing_component = BrickMetavariables
infos.summary_component_name = ''
infos.summary_component = undefined
infos.descriptions = {
	en: {
		short_tooltip_description: 'Metavariables',
		full_tooltip_description: 'Define metavariables',
		navbar_name: 'Metavariables',
	},
	fr: {
		short_tooltip_description: 'Métavariables',
		full_tooltip_description: 'Défini les métavariables',
		navbar_name: 'Métavariables',
	},
}
infos.background_color = 'purple'

brick_registerer(infos)
